module.exports = __webpack_public_path__ + "static/media/ic-download-active.868d853b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ic-download-active.svg
// module id = 654
// module chunks = 0